import React from 'react';

import { Image } from 'src/components/atoms/Image';
import * as styles from './ImageCard.styles';

export interface ImageCardProps {
  title: string;
  image: string;
  alt?: string;
  link: string;
  plainStyle?: boolean;
  className?: string;
  trackGtmEvent?: VoidFunction;
}

export const CARD_TITLE = 'card__title';

export const ImageCard = (props: ImageCardProps) => {
  const { title, link, image, alt, plainStyle = false, className, trackGtmEvent } = props;

  return (
    <a
      css={styles.CardLink}
      key={title}
      href={link}
      data-plain-style={plainStyle}
      onMouseDown={trackGtmEvent}
      className={className}
    >
      <Image src={image} alt={alt} isFullWidth />
      {title && (
        <p data-testid={CARD_TITLE} css={styles.CardTitle} data-plain-style={plainStyle}>
          <span>{title}</span>
        </p>
      )}
    </a>
  );
};
